import React, {  useEffect, useRef, useState } from "react";
import { getDate, getDefaultName, getUser, userAvatar } from "../utils";
import {
  addRefereeToCourse,
  blockUser,
  deleteCourseReferee,
  deleteUser,
  loadCourseReferees,
  loadUser,
  login,
  saveReferee,
  uploadProfileImage,
} from "cms/utils/Network";

import SelectGender from "cms/components/SelectGender";
import SelectCourses from "cms/components/SelectCourses";
import SelectCountries from "cms/components/SelectCountries";
import SelectCities from "cms/components/SelectCities";
import Modal from "react-modal";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UserGallery from "cms/components/user/UserGallery";
import TabsWidget from "cms/pages/shared/dashboard/widgets/TabsWidget";

export default function RefereeContent({ id }) {
  const [user, setUser] = useState([]);

  const [birth_year, setBirthYear] = useState(null);
  const [birth_month, setBirthMonth] = useState(null);
  const [birth_day, setBirthDay] = useState(null);
  const [gender, setGender] = useState(null);
  const [done, setDone] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [courseReferees, setCourseReferees] = useState(null);
  const [country_id, setCountryID] = useState(null);
  const [city_id, setCityID] = useState(null);

  const [error, setError] = useState(null);
  const [addError, setAddError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [profile_image_file, setProfileImageFile] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
  const [confirmModalType, setConfirmModalType] = useState(false);
  const [modal_password, setModalPassword] = useState(false);
  const [modal_error, setModalError] = useState(false);
  const [modal_loading, setModalLoading] = useState(false);
  const [bio, setBio] = useState(false);
  const [activeTab, setActiveTab] = useState("details");
  const [avatarFailed, setAvatarFailed] = useState(false);

  const profile_image_ref = useRef(null);

  const profilePhotoSrc =
    user && !Array.isArray(user) && (user.avatar || user.image)
      ? userAvatar(user)
      : "";

  const profileInitial = (() => {
    if (!user || Array.isArray(user)) return "?";
    const fn = (user.first_name || "").trim();
    if (fn.length) return fn.charAt(0).toUpperCase();
    const ln = (user.last_name || "").trim();
    if (ln.length) return ln.charAt(0).toUpperCase();
    const em = (user.email || "").trim();
    if (em.length) return em.charAt(0).toUpperCase();
    return "?";
  })();

  const mainTabs = [
    { key: "details", label: "Details", icon: "fa-id-card" },
    { key: "gallery", label: "User gallery", icon: "fa-film" },
  ];

  var admin = getUser();
  useEffect(() => {
    if (id) {
      loadUser(id).then((profile) => {

        setUser(profile);
        setAvatarFailed(false);

        if (profile) {
          if (profile.birth_date) {
            var birthdate = profile.birth_date.split("-");
            setBirthYear(birthdate[0]);
            setBirthMonth(birthdate[1]);
            setBirthDay(birthdate[2]);
          }

          setGender(profile.gender);
          setBio(profile.bio);

          if (profile.country_id) {
            setCountryID(profile.country_id);
          }

          if (profile.city_id) {
            setCityID(profile.city_id);
          }

          loadCourseReferees(profile.user).then((course_referees) => {
            setCourseReferees(course_referees);
          });
        }
        setLoading(false);
      });
    }
  }, [id]);

  const handleFileChange = (e) => {
    var file = e.target.files[0];
    if (e.target.files) {
      setProfileImageFile(file);

      setLoading(true);
      uploadProfileImage(user, file).then((response) => {
          console.log(response);
          if(response.id) {
            setUser(response);
            setAvatarFailed(false);
          }
        setLoading(false);
      });
    }
  };

  const openConfirmModal = (type) => {
    setConfirmModalType(type);
    setConfirmModalIsOpen(true);
  };
  const closeConfirmModal = () => {
    setConfirmModalIsOpen(false);
  };
  const handleChange = (e) => {
    switch (e.target.name) {
      case "modal_password":
        setModalPassword(e.target.value);
        break;

      default:
        break;
    }
  };

  const modalSubmit = () => {
    switch (confirmModalType) {
      case "Delete":
        deleteThisUser();
        break;
      case "Ban":
        blockThisUser();
        break;
      default:
        break;
    }
  };

  const deleteThisUser = () => {
    setModalLoading(true);
    setModalError(false);
    if (!modal_password) {
      setModalError("Please Enter Password");
      return;
    }

    login({ email: admin.email, password: modal_password }).then((data) => {
      setModalLoading(false);
      if (data.tokens) {
        deleteUser(user.user).then(() => {
          window.location.href = "/cms/juries";
        });
      } else {
        setModalError(data.detail);
      }
    });
  };

  const blockThisUser = () => {
    setModalLoading(true);
    setModalError(false);
    if (!modal_password) {
      setModalError("Please Enter Password");
      return;
    }

    login({ email: admin.email, password: modal_password }).then((data) => {
      setModalLoading(false);
      if (data.tokens) {
        blockUser(user).then(() => {
          alert("user profile has been deactivated");
        });
        setConfirmModalIsOpen(false);
        setLoading(false);
        var temp = user;
        temp.is_active = temp.is_active ? false : true;
        setUser(temp);
        setLoading(true);
      } else {
        setModalError(data.detail);
      }
    });
  };
  const onChange = (e) => {
    var temp = user;

    //alert(e.target.name)
    switch (e.target.name) {
      case "first_name":
        temp.first_name = e.target.value;
        setUser(temp);
        break;
      case "last_name":
        temp.last_name = e.target.value;
        setUser(temp);
        break;
      case "email":
        temp.email = e.target.value;
        setUser(temp);
        break;
      case "password":
        temp.password = e.target.value;
        setUser(temp);
        break;

      case "year":
        var date = [2021, 1, 1];
        setBirthYear(e.target.value);
        if (user.birth_date) date = user.birth_date.split("-");
        date[0] = e.target.value;
        temp.birth_date = date[0] + "-" + date[1] + "-" + date[2];
        setUser(temp);
        break;
      case "month":
        var date = [2021, 1, 1];
        setBirthMonth(e.target.value);
        if (user.birth_date) date = user.birth_date.split("-");
        date[1] = e.target.value;
        temp.birth_date = date[0] + "-" + date[1] + "-" + date[2];
        setUser(temp);
        break;
      case "day":
        var date = [2021, 1, 1];
        setBirthDay(e.target.value);
        if (user.birth_date) date = user.birth_date.split("-");
        date[2] = e.target.value;
        temp.birth_date = date[0] + "-" + date[1] + "-" + date[2];
        setUser(temp);
        break;

      default:
        break;
    }
  };
  const saveChanges = () => {
    setError(null);
    setLoading(true);

    if (user.first_name.length < 3) {
      setError("Please Enter Name");
      setLoading(false);
      return;
    }

    if (user.email.length < 5) {
      setError("Please Enter Email");
      setLoading(false);
      return;
    }

    saveReferee(user, country_id, city_id,bio).then(function (data) {
      setLoading(false);
      if (data.data && data.data.email)
        setDone("Changes saved successfully")
      else setError(JSON.stringify(data.errors, null, 4));
    });
  };

  const add = () => {
    if (!selectedCourse) {
      setAddError("Please Select a competition");
      return;
    }

    // alert(selectedCourse)
    //alert(user.user)

    setAddLoading(true);
    setAddError(false);
    if (!user) return;
    addRefereeToCourse(user.user, selectedCourse).then((data) => {
      if (data.error)
        setAddError("this jury is already asigned to selected competition");
      setAddLoading(false);

      loadCourseReferees(user.user).then((course_referees) => {
        setCourseReferees(course_referees);
      });
    });
  };

  const onValue = (value, name) => {
    var temp = user;
    switch (name) {
      case "gender":
        temp.gender = value;
        setGender(value);
        setUser(temp);
        break;
      case "course":
        setSelectedCourse(value);
        break;
      case "living_country":
        setCountryID(value);
        break;
      case "living_city":
        setCityID(value);
        break;
      default:
        break;
    }
  };
  const year_start = new Date().getFullYear() - 90;
  const year_end = new Date().getFullYear();
  const years_array = range(year_start, year_end);
  const months = new Array(11);
  months[0] = "Jan";
  months[1] = "Feb";
  months[2] = "Mar";
  months[3] = "Apr";
  months[4] = "May";
  months[5] = "Jun";
  months[6] = "Jul";
  months[7] = "Aug";
  months[8] = "Sep";
  months[9] = "Oct";
  months[10] = "Nov";
  months[11] = "Dec";
  const days_array = range(1, 31);

  function range(start, end) {
    var foo = [];
    for (var i = start; i <= end; i++) {
      foo.push(i);
    }
    return foo;
  }

  const handleDelete = (id, e) => {
    e.preventDefault();
    deleteCourseReferee(id).then((data) => {
      loadCourseReferees(user.user).then((course_referees) => {
        setCourseReferees(course_referees);
      });
    });
  };

  return (
    <>
      <div className="content-wrapper jury-page">
        <section className="content-header">
          <ol className="breadcrumb">
            <li>
              <a href="/cms/dashboard">
                <i className="fa fa-dashboard" /> Home
              </a>
            </li>
            <li>
              <a href="/cms/juries">
                <i className="fa fa-gavel" /> Juries
              </a>
            </li>
            <li className="active">Jury</li>
          </ol>
        </section>

        <Modal
          closeTimeoutMS={500}
          isOpen={confirmModalIsOpen}
          onRequestClose={closeConfirmModal}
          className="Modal confirm-modal"
          overlayClassName="Overlay"
        >
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" onClick={closeConfirmModal}>
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">{confirmModalType} Talent</h4>
            </div>
            <div className="modal-body">
              <div style={{ minHeight: 100 }}>
                <div className="col-md-12 mb-10 text-light">
                  To confirm {confirmModalType}, please enter your password
                </div>
                <div className="col-md-8">
                  <div className="input-group">
                    <span className="input-group-addon">
                      <i className="fa fa-lock" />
                    </span>
                    <input
                      type="password"
                      className="form-control modal-password"
                      onChange={handleChange}
                      placeholder="Password"
                      name="modal_password"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-primary btn-rounded"
                    onClick={modalSubmit}
                  >
                    DELETE
                  </button>
                </div>
              </div>
              {modal_error && (
                <div className="alert alert-danger">{modal_error}</div>
              )}
              {modal_loading && (
                <div className="alert alert-primary text-color-light">
                  Please wait...
                </div>
              )}
            </div>
          </div>
        </Modal>

        <section className="content">
          <div className="row">
            <div className="col-lg-4 col-md-5">
              <div className="cms-dark-box jury-profile-card">
                <div className="jury-profile-top">
                  <button
                    type="button"
                    className="jury-avatar-btn"
                    onClick={() => profile_image_ref.current && profile_image_ref.current.click()}
                    title="Change photo"
                  >
                    {profilePhotoSrc && !avatarFailed ? (
                      <img
                        className="jury-avatar"
                        src={profilePhotoSrc}
                        alt=""
                        onError={() => setAvatarFailed(true)}
                      />
                    ) : (
                      <span className="jury-avatar jury-avatar-initial" aria-hidden="true">
                        {profileInitial}
                      </span>
                    )}
                  </button>
                  <input
                    ref={profile_image_ref}
                    type="file"
                    className="hide"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                  <div className="jury-profile-meta">
                    <h2 className="jury-profile-name">
                      {user && user.first_name
                        ? `${user.first_name} ${user.last_name || ""}`
                        : "—"}
                    </h2>
                    {user && user.email && (
                      <p className="jury-profile-email">{user.email}</p>
                    )}
                  </div>
                </div>
                <ul className="jury-stat-list">
                  <li>
                    <span>Last login</span>
                    <span className="jury-stat-val">
                      {user && user.last_login ? getDate(user.last_login) : "—"}
                    </span>
                  </li>
                  <li>
                    <span>Rated</span>
                    <span className="jury-stat-val">0</span>
                  </li>
                  <li>
                    <span>Unrated</span>
                    <span className="jury-stat-val">0</span>
                  </li>
                </ul>
              </div>

              <div className="cms-dark-box jury-contests-box">
                <div className="box-header with-border">
                  <h3 className="box-title">Contests</h3>
                </div>
                <div className="box-body jury-contest-add">
                  <div className="form-group">
                    <div className="col-xs-10 col-sm-10 padding-0">
                      <SelectCourses
                        border={"1"}
                        width={"200px"}
                        callback={onValue}
                        value={selectedCourse}
                      />
                    </div>
                    <div className="col-xs-2 col-sm-2 padding-0">
                      <button
                        type="button"
                        onClick={add}
                        disabled={loading}
                        className="btn btn-cm btn-sm pull-right"
                        title="Assign contest"
                      >
                        <i className="fa fa-plus" />
                      </button>
                    </div>
                    <div className="clearfix" />
                  </div>
                  {addError && (
                    <div className="alert alert-danger mt2">{addError}</div>
                  )}
                  {addLoading && (
                    <div className="alert alert-primary mt2">Please wait…</div>
                  )}
                </div>
                <ul className="jury-contest-list">
                  {courseReferees &&
                    courseReferees.map((item) => (
                      <li key={item.id} className="jury-contest-item">
                        <a href={`/cms/course/${item.course.id}`}>
                          {getDefaultName(item.course.names)}
                          <small>
                            {item.created_at && item.created_at.split("T")[0]}
                          </small>
                        </a>
                        <button
                          type="button"
                          className="btn btn-cm btn-sm jury-contest-remove"
                          onClick={(e) => {
                            e.preventDefault();
                            if (
                              window.confirm(
                                "Are you sure you wish to delete this item?"
                              )
                            ) {
                              handleDelete(item.id, e);
                            }
                          }}
                          title="Remove from contest"
                        >
                          <i className="fa fa-trash" />
                        </button>
                      </li>
                    ))}
                </ul>
              </div>

              <div className="jury-actions">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => openConfirmModal("Delete")}
                >
                  <i className="fa fa-trash" /> Delete
                </button>
                <button
                  type="button"
                  className="btn btn-warning btn-sm"
                  onClick={() => openConfirmModal("Ban")}
                >
                  <i className="fa fa-ban" />{" "}
                  {user && user.is_active ? "Deactivate" : "Activate"}
                </button>
              </div>
            </div>

            <div className="col-lg-8 col-md-7">
              <TabsWidget
                tabs={mainTabs}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                className="cms-page-tabs"
              />
              <div className="cms-page-tab-content">
                {activeTab === "details" && (
                  <>
                    <div className="jury-tab-panel">
                      <h2 className="jury-tab-panel-title">Profile &amp; account</h2>
                        <form className="form-horizontal">
                          <div className="form-group row mb-8">
                            <div className="col-sm-6 mb-8">
                              <label className="control-label">First name</label>
                              <input
                                type="text"
                                defaultValue={user && user.first_name}
                                name="first_name"
                                onChange={onChange}
                                className="form-control"
                                placeholder="First name"
                              />
                            </div>
                            <div className="col-sm-6 mb-8">
                              <label className="control-label">Last name</label>
                              <input
                                type="text"
                                defaultValue={user && user.last_name}
                                name="last_name"
                                onChange={onChange}
                                className="form-control"
                                placeholder="Last name"
                              />
                            </div>
                          </div>

                          <div className="form-group row mb-8">
                            <div className="col-sm-6 mb-8">
                              <label className="control-label">Email</label>
                              <input
                                type="text"
                                defaultValue={user && user.email}
                                name="email"
                                onChange={onChange}
                                className="form-control"
                                placeholder="Email"
                              />
                            </div>
                            <div className="col-sm-6 mb-8">
                              <label className="control-label">Password</label>
                              <input
                                type="text"
                                name="password"
                                onChange={onChange}
                                className="form-control"
                                placeholder="Password"
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <div className="col-md-12 mb-8">
                              <label className="control-label">Gender</label>
                              <div>
                                <SelectGender
                                  border={"1"}
                                  width={"200px"}
                                  value={gender}
                                  callback={onValue}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-12 mb-8">
                              <label className="control-label">Location</label>
                              <div className="clearfix">
                                <div className="pull-left margin-r-10 mb-8 max-200">
                                  <SelectCountries
                                    name={"living_country"}
                                    placeholder="From"
                                    value={country_id}
                                    kurds={1}
                                    callback={onValue}
                                  />
                                </div>
                                <div className="pull-left max-200">
                                  <SelectCities
                                    name={"living_city"}
                                    key={country_id}
                                    country={country_id}
                                    value={city_id}
                                    callback={onValue}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group padding-x-15">
                            <label className="control-label">Bio</label>
                            <CKEditor
                              editor={ClassicEditor}
                              data={bio ?? ""}
                              onReady={() => {}}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setBio(data);
                              }}
                            />
                          </div>

                          <div className="jury-tab-actions">
                            <a
                              href="/cms/juries"
                              className="btn btn-cm"
                            >
                              Cancel
                            </a>
                            <button
                              type="button"
                              onClick={saveChanges}
                              disabled={loading}
                              className="btn btn-cm"
                            >
                              Save changes
                            </button>
                          </div>
                        </form>
                    </div>
                    {error && (
                      <div className="alert alert-danger mt-10">{error}</div>
                    )}
                    {done && (
                      <div className="alert alert-success mt-10">{done}</div>
                    )}
                    {loading && (
                      <div className="alert alert-info mt-10">Please wait…</div>
                    )}
                  </>
                )}

                {activeTab === "gallery" &&
                  (user && user.user ? (
                    <UserGallery userId={user.user} />
                  ) : (
                    <p className="jury-gallery-empty mb-0">Loading jury profile…</p>
                  ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
